import React, { useEffect, useMemo } from 'react';
import useToggle from 'hooks/useToggle';
import { useSelector } from 'react-redux';

import { connectedPaymentProviderIdSelector } from 'domain/paySettings';
import { LayoutPayCompanyContext } from 'components/mui/Layouts/PayCompany/LayoutPayCompanyContext';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { DrawerHeader, DrawerToggle, DrawerToggleIcon } from 'components/mui/Layouts/components/Drawer';
import { LayoutRoot, LayoutContent } from 'components/mui/Layouts/components/Layout';
import { AppBarExpanded, AppBarItemDivider } from 'components/mui/Layouts/components/AppBar';
import LayoutCompanyDrawer from 'components/mui/Layouts/Company/components/Drawer';
import AppbarLogoCompany from 'components/mui/Layouts/components/AppbarLogoCompany';
import LocaleSelect from 'components/mui/LocaleSelect';
import AccountDropdown from 'components/mui/Layouts/components/AccountDropdown';
import EventsHistoryIconButton from 'components/mui/Layouts/components/EventsHistoryPanel/EventsHistoryIconButton';
import FullscreenIconButton from 'components/mui/Layouts/components/FullscreenIconButton';
import HelpDropdown from '../components/HelpDropdown';
import ApplicationDropdown from 'components/mui/Layouts/components/ApplicationDropdown';

const LayoutPayCompany = ({ children, DrawerContent }) => {
  const connectedPaymentProviderId = useSelector(connectedPaymentProviderIdSelector);

  const [toggle, onToggle] = useToggle(true);

  const contextValue = useMemo(() => ({ toggle, onToggle }), [toggle, onToggle]);

  useEffect(() => {
    onToggle(!!connectedPaymentProviderId);
  }, [connectedPaymentProviderId, onToggle]);

  return (
    <LayoutRoot>
      <LayoutPayCompanyContext.Provider value={contextValue}>
        <LayoutCompanyDrawer open={toggle} onToggle={onToggle}>
          {DrawerContent}
        </LayoutCompanyDrawer>
      </LayoutPayCompanyContext.Provider>
      <AppBarExpanded open={toggle}>
        <Box
          flexShrink={1}
          sx={{
            minWidth: 200,
            maxWidth: {
              xs: '33%',
              lg: '47%',
            },
          }}
        >
          <AppbarLogoCompany />
        </Box>
        <Stack direction="row" alignItems="center" spacing={1} flexShrink={0} ml="auto">
          <FullscreenIconButton />
          <AppBarItemDivider />
          <EventsHistoryIconButton />
          <HelpDropdown />
          <LocaleSelect flagOnly />
          <ApplicationDropdown />
          <AccountDropdown />
        </Stack>
        {/* placed here because Drawer has overflow: hidden */}
        <DrawerToggle color="primary" size="small" onClick={onToggle}>
          <DrawerToggleIcon open={toggle} />
        </DrawerToggle>
      </AppBarExpanded>

      <LayoutContent>
        <DrawerHeader />
        {children}
      </LayoutContent>
    </LayoutRoot>
  );
};

export default LayoutPayCompany;
